import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateTimeInput,
  Edit,
  FormTab,
  FunctionField,
  List,
  NumberInput,
  SearchInput,
  SelectInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { BodyLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";
import CoverTextColorField from "../ui/forms/CoverTextColorField";

const filters = [<SearchInput key="q" source="q" alwaysOn />];
const MEDIA_ACCEPT = "video/*,audio/*";

const MEDIA_TYPE_CHOICES = [
  { id: "video", name: "Видео" },
  { id: "audio", name: "Аудио" },
];

const PhVideoForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Публикация">
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <DateTimeInput source="PublishedAt" label="Дата публикации" fullWidth />
          <SelectInput
            source="MediaType"
            label="Тип медиа"
            choices={MEDIA_TYPE_CHOICES}
            defaultValue="video"
            helperText="Определяет плеер в приложении: видео или аудио"
            fullWidth
          />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Медиа">
          <LocalizedFileControls
            baseSource="Image"
            label="Превью (poster)"
            kind="image"
            helperText="JPG/PNG — обложка для списка и плеера"
          />
          <CoverTextColorField />
          <LocalizedFileControls
            baseSource="Video"
            label="Медиафайл"
            kind="media"
            accept={MEDIA_ACCEPT}
            required
            helperText="MP4, MP3, WAV, M4A — видео или аудио через файловый сервис"
          />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <BodyLangFields lang="AZ" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="AZ" label="Превью (poster)" kind="image" />
        <LocalizedFileLangField
          baseSource="Video"
          lang="AZ"
          label="Медиафайл"
          kind="media"
          accept={MEDIA_ACCEPT}
          required
        />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <BodyLangFields lang="RU" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="RU" label="Превью (poster)" kind="image" />
        <LocalizedFileLangField
          baseSource="Video"
          lang="RU"
          label="Медиафайл"
          kind="media"
          accept={MEDIA_ACCEPT}
          required
        />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <BodyLangFields lang="EN" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="EN" label="Превью (poster)" kind="image" />
        <LocalizedFileLangField
          baseSource="Video"
          lang="EN"
          label="Медиафайл"
          kind="media"
          accept={MEDIA_ACCEPT}
        />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhVideoList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Заголовок" />
        <TextField source="MediaType" label="Тип" />
        <FunctionField
          label="Превью"
          render={(record: { Image?: string }) => <FilePreviewLink value={record.Image} />}
        />
        <FunctionField
          label="Медиа"
          render={(record: { Video?: string }) => <FilePreviewLink value={record.Video} />}
        />
        <TextField source="PublishedAt" label="Дата" />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhVideoEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhVideoForm />
  </Edit>
);

export const PhVideoCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhVideoForm />
  </Create>
);
